import { useEffect, useRef } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Modal, Form, Title } from '@bancobarigui/barihaus';

import { ItemForm } from './ItemForm';
import { ModalFooter } from '@/components/ModalFooter';
import { AddressFormRef } from '@/components/AddressForm';

import { ItemFormData, useItemModal } from './useItemModal';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ItemFormData) => void;
  initialData?: ItemFormData | undefined;
};

export function ItemModal({ open, onClose, onSubmit, initialData }: Props) {
  const addressFormRef = useRef<AddressFormRef>(null);
  const { form, handleFormSubmit, inspectionTypes, propertyTypes, reasons } =
    useItemModal({
      onClose,
      onSubmit,
      addressFormRef,
    });

  useEffect(() => {
    if (open) {
      if (initialData) {
        form.setFieldsValue(initialData);
        addressFormRef.current?.markCepAsValidated();
      } else {
        form.resetFields();
        addressFormRef.current?.resetAddressForm();
      }
    }
  }, [open, initialData, form]);

  return (
    <Modal
      centered
      open={open}
      width={900}
      footer={null}
      onCancel={onClose}
      className="space-y-8"
      closeIcon={<CloseOutlined />}
    >
      <Title level={2}>{initialData ? 'Editar Item' : 'Adicionar Item'}</Title>

      <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
        <ItemForm
          form={form}
          reasons={reasons}
          propertyTypes={propertyTypes}
          inspectionTypes={inspectionTypes}
          addressFormRef={addressFormRef}
        />

        <ModalFooter onClose={onClose} />
      </Form>
    </Modal>
  );
}
